import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import UnifiedHeader from '../components/UnifiedHeader'
import DivisionCard from '../components/DivisionCard'
import { DIVISIONS, UI, ROUTE } from '../config'
import { loadLastVehicle } from '../extras/cookies'
import { isOffline } from '../services/offlineDetect'
import { buildStaticMobileDropdown } from '../extras/unifiedHeaderNavigation'

import '../styles/LandingPage.scss'

export default class LandingPage extends Component {
  static propTypes = {
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
    }).isRequired,
  }

  componentDidMount() {
    if (isOffline()) {
      this.props.history.replace(ROUTE.OFFLINE)
      return
    }

    const last = loadLastVehicle()

    if (last && last.brandKey && last.year && last.model) {
      this.props.history.replace(`/${last.brandKey}/guide/${last.year}/${last.model}/browse`)
    }
  }

  render() {
    return (
      <div className="LandingPage theme-forest-river">
        <Helmet>
          <title>{UI.UNIFIED_APP_TITLE}</title>
        </Helmet>

        <UnifiedHeader
          breadcrumb={<span className="LandingPage-welcome">{UI.LANDING_WELCOME}</span>}
          mobileDropdown={buildStaticMobileDropdown(UI.LANDING_WELCOME)}
        />

        <main className="LandingPage-content">
          <h1 className="LandingPage-intro">{UI.LANDING_INTRO}</h1>
          <div className="LandingPage-grid">
            {DIVISIONS.map(division => (
              <DivisionCard key={division.key} division={division} />
            ))}
          </div>
        </main>
      </div>
    )
  }
}
